export const isObject = <ObjectType = Record<string, unknown>>(
  val: unknown,
): val is ObjectType =>
  typeof val === 'object' && val !== null && !Array.isArray(val)
